const prefix = 'plays100:'

export function readNumber(key: string): number {
  try { return Number(localStorage.getItem(prefix + key)) || 0 } catch { return 0 }
}

export function writeBest(key: string, score: number): number {
  const next = Math.max(readNumber(key), score)
  try { localStorage.setItem(prefix + key, String(next)) } catch { /* storage is optional */ }
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('plays100:best-score', { detail: { key, score: next } }))
  return next
}

export function readJson<T>(key: string, fallback: T): T {
  try { return JSON.parse(localStorage.getItem(prefix + key) || '') as T } catch { return fallback }
}

export function writeJson<T>(key: string, value: T): void {
  try { localStorage.setItem(prefix + key, JSON.stringify(value)) } catch { /* storage is optional */ }
}
